import { tShopModel } from './tShopModel';
import { TshopModule } from '../pages/tshop/tshop.module';

export class tInvtModel {

    id: number;
    shopID: string;
    invtType: number;
    invtSubType: number;

    invtDocNumber: string;
    invtDocRemark: string;
    invtPostDate: Date;
    invtWarehouseID: string;

    fromToWH: string;
    invtBinID: string;
    invtItemID: string;
    invtItemDesc: string;
    invtInQty: number;


    invtInUnitCost: number;
    invtOutQty: number;
    invtOutUnitCost: number;
    invtEBQty: number;
    invtEBUnitCost: number;

    LastModifyDatetime: Date;
    LastModifyUserID: string;

    itemType: number;
    remark1: string;
    remark2: string;
    remark3: string;
    remark4: string;
    remark5: string;

    invtStockUnit: number;
    invtLineAmt: number;
    mediBatch:string;
    meditExpiry:Date;

}

export class tInvtInBoundModel extends tInvtModel {
    purchaseUnitNameEng:string;
    mconvConvQty:number;
}

export class tInvtModelOnHand extends tInvtModel {
    lastcostLMUN: string;
    lastcostLMD: Date;

    itemCateID: string;
    itemCateName: string;
    stdCost:number;
}
export class BatchNumberEnquiryModel{
    shopID:string;
    invtDocNumber:string;
    invtWarehouseID:string;
    FromToWH:string;
    mediBatch:string;
    meditExpiry:Date;
    mediCode:string;
    mediDesc:string;
    unit:number;
    invtInQty:number;
    invtOutQty :number;
  
}
export class BatchNumberEnquiryMediModel{
    mediBatch:string;
    mediCode:string;
    mediBarCode:string;
    mediName:string;
    mediBrand:string;
    meditExpiry:Date;
    invtBalance:number;
  
}
export class BatchNumberEnquiryRemainQtyModel{
    shopID:string;
    invtDocNumber:string;
    mediBatch:string;
    meditExpiry:Date;
    mediCode:string;
    mediDesc:string;
    unit:number;
    remainQty:number;
}

export class tInvtModel_invtType {

    // 1: Inbound
    // 2: Outbound
    // 3: MonthEndBalance

    static Inbound: number = 1;
    static Outbound: number = 2;
    static MonthEndBalance: number = 3;


    value: number;
    displayName: string;
    displayEngName: string;

    constructor(value, displayName, displayEngName) {
        this.value = value;
        this.displayName = displayName;
        this.displayEngName = displayEngName;
    }
}

export class tInvtModel_invtSubType {


    static GRN: number = 101;
    static StockIn: number = 102;
    static Void: number = 103;

    static Sales: number = 201;
    static StockOut: number = 202;

    static MonthEndBalance: number = 301;

    value: number;
    displayName: string;
    displayEngName: string;

    constructor(value, displayName, displayEngName) {
        this.value = value;
        this.displayName = displayName;
        this.displayEngName = displayEngName;
    }
}


export class StockManagementClass {
    docNumber: string;
    detailInfo: tInvtModel[];
}


export class tInvtModel_PrintModel {
    shopModel: tShopModel;
    fromToWhsName: string;
    tInvtDataList: tInvtModel[];
    itemType: number;
}

export class tInvtItemCostModel{
    cost: number;
}






export class stockMovement extends tInvtModel {

    patientChiName: string;
    grnVendorName: string;
    pkPatientChiName: string;

    fromToWHName: string;

    lastInvIntQty: number;
    lastInvOuttQty: number;

}

